import { fetchJson } from './api_helpers';
import { API_BASE_URL } from '../constants';

const ENTITY_ID_PREFIX = '44';
const ENTITY_ID_SUFFIX_MODULUS = 100000;

async function computeAlertEntityId(linkToContent) {
  const value = String(linkToContent || '').trim();
  const digestBuffer = await window.crypto.subtle.digest('SHA-256', new TextEncoder().encode(value));
  const digestBytes = new Uint8Array(digestBuffer);
  // Use first 12 hex chars (48 bits) to keep deterministic mapping without BigInt.
  const digestHexPrefix = Array.from(digestBytes.slice(0, 6), (byte) => byte.toString(16).padStart(2, '0')).join('');
  const suffix = (parseInt(digestHexPrefix, 16) % ENTITY_ID_SUFFIX_MODULUS).toString().padStart(5, '0');
  return `${ENTITY_ID_PREFIX}${suffix}`;
}

function buildAlertNotes({ fullName, emailAddress, description }) {
  return [
    `Full Name: ${fullName}`,
    `Mail Address: ${emailAddress}`,
    `Description: ${description}`,
  ].join(', ');
}

/**
 * Send "Report an Error" form data to the contact email endpoint.
 *
 * This is feedback about CyberWell's own data — a correction, not a report of
 * antisemitic content — so it reaches staff as mail and never enters the ingest
 * queue. Content reports go through sendAlertParse instead.
 * @param {Object} payload
 * @returns {Promise<*>}
 */
export function sendContactEmail(payload) {
  return fetchJson(`${API_BASE_URL}/awatch/contact/email`, {
    method: 'POST',
    body: JSON.stringify({
      fields: {
        'Full name': payload.fullName,
        Email: payload.emailAddress,
        'Account name': payload.accountName,
        'Link to content': payload.contentLink,
        Explanation: payload.explanation,
      },
    }),
  });
}

/**
 * Send "Alert us" form data to DB ingest endpoint.
 * @param {Object} payload
 * @returns {Promise<*>}
 */
export async function sendAlertParse(payload) {
  const fullName = payload?.fullName?.trim() || '';
  const emailAddress = payload?.emailAddress?.trim() || '';
  const linkToContent = payload?.linkToContent?.trim() || '';
  const description = payload?.description?.trim() || '';

  const parsePayload = {
    EntityId: await computeAlertEntityId(linkToContent),
    CreatedDate: new Date().toISOString(),
    Url: linkToContent,
    Notes: buildAlertNotes({ fullName, emailAddress, description }),
    request_type: 'manual_scrapping',
    status: 1,
  };

  return fetchJson(`${API_BASE_URL}/awatch/parse`, {
    method: 'POST',
    body: JSON.stringify(parsePayload),
  });
}
